<template>

  <svg
    t="1632727333729"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5427"
    width="64"
    height="64"
  ><path d="M116.4921875 116.4921875h791.015625v791.015625h-791.015625v-791.015625z" p-id="5428" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeSquare',
} as DefineComponent
</script>